import BasketListItem from 'components/Checkout/PromoSection/BasketList/BasketListItem/BasketListItem';
import withBasketListItemProps from 'viewModel/checkout/basketList/basketListItem/withBasketListItemProps';
const ConnectedBasketListItem = withBasketListItemProps(BasketListItem);

export default ConnectedBasketListItem;
